import BaseStore from './BaseStore';
import rp from 'request-promise';
import config from '../config';
import { getTenantHeaders } from '../components/TenantHeaders';

export class QrCodeStore extends BaseStore {
  constructor() {
    super();
    this.observable({
      loading: false,
      bed: {},
      status: {
        error: false,
        message: '',
      },
    });
  }

  async getBed(id, status) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/bed/${id}`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, config.api.token);
      if (res.statusCode === 200) {
        const bed = res.body || {};
        this.bed = bed;
        if (!bed.patient || bed.patient === null) {
          this.status = {
            error: true,
            message: 'No patient',
          };
          return false;
        }
        if (!bed.patient.devices || bed.patient.devices.length === 0) {
          this.status = {
            error: true,
            message: 'No device',
          };
          return false;
        } else {
          if (status === 'on' && bed.patient.devices[0].status === 'ACTIVATE_ON') {
            this.status = {
              error: true,
              message: 'Status device already ON',
            };
            return false;
          }
          if (status === 'off' && bed.patient.devices[0].status === 'ACTIVATE_OFF') {
            this.status = {
              error: true,
              message: 'Status device already OFF',
            };
            return false;
          }
          return bed.patient.devices[0];
        }
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async updateDevice(data) {
    this.loading = true;
    try {
      const res = await rp
        .put(`${config.api.url}/${config.api.version}/device/${data.id}`, {
          body: data,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, config.api.token);
      if (res && res.statusCode === 200) {
        const device = res.body || {};
        this.status = {
          error: false,
          message: device.status === 'ACTIVATE_ON' ? 'Successfully Activated ON' : 'Successfully Activated OFF',
        };

        let devices = [];
        devices.push(device);
        await rp
          .post(`${config.api.url}/${config.api.version}/fetch`, {
            body: {
              subGroupId: this.bed.subGroupId,
              type: 'deviceUpdate',
              devices: devices,
              patientId: this.bed.patientId,
            },
            json: true,
            authorization: true,
            resolveWithFullResponse: true,
            headers: {
              ...getTenantHeaders(),
            },
          })
          .auth(null, null, true, config.api.token);

        return device;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }
}

export default new QrCodeStore();
